import type { GoogleCalendarTranslations } from '../interfaces/google-calendar';

export const googleCalendarTranslations: GoogleCalendarTranslations = {
  integrationSectionTitle: 'Google Calendar',
  integrationSectionDescription:
    'Conecte seu Google Calendar para que o {{brand}} possa ler e criar eventos em seu nome.',
  connectedBadge: 'Conectado',
  connectButton: 'Conectar Calendar',
  redirectDisclaimer:
    'Você será redirecionado ao Google para autorizar o acesso. As permissões podem ser revogadas a qualquer momento.',
  configureButton: 'Configurar',
  reconnectButton: 'Reconectar',
  disconnectButton: 'Desconectar',
  openCalendarButton: 'Abrir Google Calendar',

  emailAccountLabel: 'Conta conectada',
  primaryCalendarLabel: 'Calendário principal',
  lastSyncLabel: 'Última sincronização',
  watchExpiresLabel: 'O canal de notificações expira',
  lastErrorLabel: 'Último aviso do Google',

  drawerTitle: 'Configurações do Google Calendar',
  drawerDescription:
    'Veja a conta conectada, force uma reconexão ou desconecte o {{brand}} do seu calendário.',

  disconnectDialogTitle: 'Desconectar Google Calendar?',
  disconnectDialogDescription:
    'O {{brand}} deixará de ler seus eventos. Os eventos já sincronizados permanecerão no banco de dados até que você os apague manualmente.',
  disconnectDialogCancel: 'Cancelar',
  disconnectDialogConfirm: 'Desconectar',

  successToast: 'Google Calendar conectado com sucesso.',
  errorToast: 'Não foi possível concluir a conexão com o Google Calendar.',
  disconnectedToast: 'Google Calendar desconectado.',

  errorTitle: 'Algo deu errado ({{step}})',
  retryButton: 'Tentar novamente',
};
